/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMerchantNeighborhoodsEnrollmentsRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {GetMerchantNeighborhoodsEnrollmentsResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const getMerchantNeighborhoodsEnrollments = (request: GetMerchantNeighborhoodsEnrollmentsRequest, options?: CashRequestOptions) => post<GetMerchantNeighborhoodsEnrollmentsRequest, GetMerchantNeighborhoodsEnrollmentsResponse>("/2.0/cash/get-merchant-neighborhoods-enrollments", request, {...options, rejectOnError: true })